import { env } from 'config';
import { OrderType } from 'enums';
import {
  QueryParams,
  SummaryStatistic,
  PaginatedData,
  RequisitesWithStatistic,
  Requisites,
  PayoutRequisites,
  RequisitesStatistic,
  SingleRequisitesStatistics,
} from 'types';
import { apiUtils } from 'utils';

const url = `${env.apiUrl}/statistics`;

const getAgentsSummary =
  (orderType: OrderType) =>
  async (params: QueryParams): Promise<SummaryStatistic> =>
    (
      await apiUtils.getWithQueryParams(
        `${url}/${orderType}/agents/summary`,
        params,
      )
    ).data;

const getSummary =
  (orderType: OrderType) =>
  async (params: QueryParams): Promise<SummaryStatistic> =>
    (await apiUtils.getWithQueryParams(`${url}/${orderType}/summary`, params))
      .data;

const getDailySummary =
  (orderType: OrderType) =>
  async (params: QueryParams): Promise<Record<string, SummaryStatistic>> =>
    (
      await apiUtils.getWithQueryParams(`${url}/${orderType}/summary/daily`, {
        ...params,
        ...apiUtils.getTimezoneOffsetQuery(),
      })
    ).data;

const getRequisitesPaginated =
  (orderType: OrderType) =>
  async (
    params: QueryParams,
  ): Promise<
    PaginatedData<RequisitesWithStatistic<Requisites | PayoutRequisites>>
  > =>
    (
      await apiUtils.getWithQueryParams(
        `${url}/${orderType}/requisites`,
        params,
      )
    ).data;

const getDailyRequisitesPaginated =
  (orderType: OrderType, id: string) =>
  async (
    params: QueryParams,
  ): Promise<PaginatedData<Record<string, RequisitesStatistic>>> =>
    (
      await apiUtils.getWithQueryParams(
        `${url}/${orderType}/requisites/${id}/daily`,
        {
          ...params,
          ...apiUtils.getTimezoneOffsetQuery(),
        },
      )
    ).data;

const getSingleRequisitesStatistics = async (
  orderType: OrderType,
  id: string,
): Promise<SingleRequisitesStatistics[]> => [
  (
    await apiUtils.getWithQueryParams(
      `${url}/${orderType}/requisites/${id}`,
      apiUtils.getTimezoneOffsetQuery(),
    )
  ).data,
];

export const statisticsApi = {
  getAgentsSummary,
  getSummary,
  getDailySummary,
  getRequisitesPaginated,
  getDailyRequisitesPaginated,
  getSingleRequisitesStatistics,
};
